import DrawButton from '../../components/DrawButton'
import EnergyBadge from '../../components/EnergyBadge'

import { Container } from './styles'

interface ActionSectionProps {
  onDraw: () => void
  coinBalance: number
  isCoinLoading: boolean
  isDrawing: boolean
}

export default function ActionSection({ onDraw, coinBalance, isCoinLoading, isDrawing }: ActionSectionProps) {
  return (
    <Container>
      <EnergyBadge count={coinBalance} />
      <DrawButton onClick={onDraw} isDisabled={coinBalance === 0 || isCoinLoading} isLoading={isDrawing} />
    </Container>
  )
}
